/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ApproversIcon extends BaseIcon {
    getChildren = () => [
        <path fill={this.getColor()} transform="translate(-1384 -888.5)"
              d="M1404.22,898.656a6.756,6.756,0,0,0-3.29-.649,9.416,9.416,0,0,0-1.55.117,4,4,0,1,0-3.38,1.864,3.794,3.794,0,0,0,.56-0.057,5.718,5.718,0,0,0-.51,2.074c-0.01,0-.03,0-0.05,0-6.07,0-10.99-6-10.99-6s4.92-6,10.99-6,11,6,11,6A21.011,21.011,0,0,1,1404.22,898.656Zm-8.21-.654a2,2,0,1,1,2-2A2,2,0,0,1,1396.01,898Zm3.45,8.986c0.58,0,.94,0,1.3.007-1.81-.091-2.77-1.434-2.77-3.367,0-2,0-3.626,2.96-3.626,3.13,0,3.03,1.623,3.03,3.626,0,1.947-1.04,3.3-2.88,3.37,0.37,0,.8.007,1.49,0.007,2.77,0,4.4,2.774,4.4,2.774v1.213h-12l0.02-1.31S1396.64,906.988,1399.46,906.988Z"
        />
    ]
    getViewBox = () => '0 0 24 24'
}
